<template>
  <div class="tag-wrapper" @mouseleave="showTable = false">
    <span
      class=" label tag-tech table-tag-content"
      @mouseenter="showTable = true"
      >#{{ list.length }} <i class="fas fa-tools"></i
    ></span>

    <div
      v-if="list.length && showTable"
      class="tag-table pop-up-for-tags"
      @mouseenter="showTable = false"
    >
      <div class="table-responsive">
        <table class="table">
          <!--          <thead>
                    <tr class="bg-info">
                      <th>Date</th>
                      <th>Time</th>
                      <th>Asset</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Agent</th>
                    </tr>
                    </thead>-->

          <tbody>
            <tr v-for="(item, idx) in list" :key="item.id">
              <td v-if="idx < 7">{{ item.created_at | shortTime }}</td>
              <td v-if="idx < 7">{{ formatDateTable(item.created_at) }}</td>
              <td v-if="idx < 7">{{ item.asset | lowercase }}</td>
              <td v-if="idx < 7">{{ item.from }}</td>
              <td v-if="idx < 7">{{ item.to }}</td>
              <td v-if="idx < 7">
                {{ item.user ? item.user.full_name : "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "client-activity-log",

  props: {
    list: {
      type: Array
    }
  },

  data() {
    return {
      showTable: false
    };
  },
  methods: {
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-tech {
  font-size: 12px !important;
  background-color: #f59304;
  /*font-size: 12px;*/
  /*color: white;*/
  /*margin: 1px;*/
  /*!*padding: 3px;*!*/
  /*cursor: pointer;*/
  /*animation: flash linear 1s;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.label {
  font-weight: 500 !important;
}
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-table {
  bottom: 40px !important;
  border: solid 1px #f59304;
  height: auto;
  font-weight: 400;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
}
.table {
  margin-bottom: unset;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
tbody > tr:nth-of-type(odd) {
  background-color: lightgrey;
}
.table-tag-content {
  min-width: 35px !important;
}
</style>
